import * as React from 'react';
import cx from 'clsx';
import { getAddonIconStyle } from './get-addon-icon-style';
import sharedStyles from './shared-groups.module.css';
import styles from './addons-group.module.css';

export interface Addon {
  description: string;
  iconLightPath: string;
  iconDarkPath: string;
  isAvailable?: boolean;
}

export interface AddonsGroupProps {
  title: string;
  addons: Addon[];
}

export function AddonsGroup({ title, addons }: AddonsGroupProps): React.ReactNode {
  return (
    <div>
      <h3 className={cx('body-prominent mb-8', sharedStyles.title)}>{title}</h3>
      <ul className={sharedStyles.list}>
        {addons.map(({ description, iconLightPath, iconDarkPath, isAvailable = true }) => (
          <li
            className={cx(
              sharedStyles['list-item'],
              styles['list-item'],
              !isAvailable && styles['not-available'],
              'mb-8'
            )}
            data-testid="addon-description"
            key={description}
          >
            <div
              aria-hidden="true"
              className={cx('mr-16', sharedStyles.image, styles.image)}
              style={getAddonIconStyle(iconLightPath, iconDarkPath)}
            />
            <span>{description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
